import { amountToDisplayValue, Color, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import type { ExpertTrialBalanceHeaderKpis } from '../../types/expertTrialBalanceHeaderKpis'
import * as Styled from './styles'

interface ExpertTrialBalanceResultHeaderProps {
  currencyId?: string
  headerKpis: ExpertTrialBalanceHeaderKpis
}

interface ResultKpiItemProps {
  currencyId?: string
  label: string
  value: number
  withDivider?: boolean
}

const ResultKpiItem = ({ currencyId, label, value, withDivider = false }: ResultKpiItemProps): ReactElement => (
  <Styled.ResultItem withDivider={withDivider}>
    <Text as="span" color={Color.Grey400} variant="bodyMD" weight="semiBold">
      {label}:
    </Text>
    <Text as="span" color={Color.Grey500} variant="bodyMD" weight="semiBold">
      {amountToDisplayValue(value, false, currencyId)}
    </Text>
  </Styled.ResultItem>
)

export const ExpertTrialBalanceResultHeader = ({
  currencyId,
  headerKpis,
}: ExpertTrialBalanceResultHeaderProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Styled.ResultHeaderWrapper>
      <ResultKpiItem
        currencyId={currencyId}
        label={t('expert_trial_balance.header.result')}
        value={headerKpis.current}
      />
      {headerKpis.previous !== null && (
        <ResultKpiItem
          currencyId={currencyId}
          label={t('expert_trial_balance.header.result_previous')}
          value={headerKpis.previous}
          withDivider
        />
      )}
    </Styled.ResultHeaderWrapper>
  )
}
